import { useUser } from '../useUser/index'
import { useFetch } from '../useFetch/index'

export const useDbRestore = () => {
  const { accessToken } = useUser()

  return useFetch('/api/restore-db', {
    headers: {
      'totalmilk-login-token': accessToken,
    },
  })
}
